import { Reveal } from "@/components/site/motion";
import { Sparkles } from "lucide-react";

export const PartnerVision = () => (
  <section id="partner-vision" data-testid="partner-vision-section" className="relative overflow-hidden bg-ink py-28 sm:py-36 text-white">
    <div className="grain" />
    <div className="absolute inset-0 grid-bg opacity-[0.08]" />
    <div className="relative mx-auto max-w-5xl px-5 sm:px-8">
      <Reveal>
        <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3.5 py-1.5">
          <Sparkles className="h-3.5 w-3.5 text-cobalt" />
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-white/70">Our Vision</span>
        </div>
      </Reveal>
      <Reveal delay={0.06}>
        <h2 className="mt-7 font-display font-extrabold tracking-tighter text-4xl sm:text-6xl leading-[1]">
          Building one of the UK's most{" "}
          <span className="text-cobalt">intelligent admissions platforms.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.12}>
        <p className="mt-8 max-w-3xl text-xl leading-relaxed text-white/70">
          OpenDegree combines artificial intelligence, automation and human expertise to simplify university
          admissions — while improving the experience for both applicants and higher education providers.
        </p>
      </Reveal>
    </div>
  </section>
);
